import { ChangeEvent, useState, forwardRef } from 'react';
import './Field.css';

const EyeIcon = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M12 5C7 5 2.73 8.11 1 12.5C2.73 16.89 7 20 12 20C17 20 21.27 16.89 23 12.5C21.27 8.11 17 5 12 5ZM12 17.5C9.24 17.5 7 15.26 7 12.5C7 9.74 9.24 7.5 12 7.5C14.76 7.5 17 9.74 17 12.5C17 15.26 14.76 17.5 12 17.5ZM12 9.5C10.34 9.5 9 10.84 9 12.5C9 14.16 10.34 15.5 12 15.5C13.66 15.5 15 14.16 15 12.5C15 10.84 13.66 9.5 12 9.5Z" 
        fill="#182c47"/>
    </svg>
);

const EyeClosedIcon = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M12 6.5C15.79 6.5 19.17 8.63 20.82 12C20.23 13.42 19.4 14.68 18.41 15.72L19.82 17.13C21.21 15.73 22.31 14.01 23 12C21.27 7.61 17 4.5 12 4.5C10.6 4.5 9.26 4.75 8 5.2L9.17 6.37C10.06 6.42 11.02 6.5 12 6.5ZM10.93 7.14L13 9.21C13.57 9.46 14.03 9.92 14.28 10.49L16.35 12.56C16.43 12.38 16.49 12.19 16.49 12C16.49 10.34 15.15 9 13.49 9C13.3 9 13.11 9.06 12.93 9.14ZM2.01 3.87L4.69 6.55C3.06 7.83 1.77 9.53 1 11.5C2.73 15.89 7 19 12 19C13.52 19 14.98 18.71 16.32 18.18L19.74 21.6L21.15 20.19L3.42 2.45L2.01 3.87ZM9.51 11.37L12.12 13.98C12.08 13.99 12.04 14 12 14C10.34 14 9 12.66 9 11C9 10.96 9.01 10.92 9.02 10.88L7.86 9.72C7.08 10.8 6.5 11.96 6.17 13C7.82 15.37 9.78 16 12 16C12.53 16 13.04 15.93 13.53 15.8L11.72 13.99C11.64 14 11.57 14 11.49 14C10.67 14 9.99 13.32 9.99 12.5C10 12.12 10.19 11.77 10.51 11.37Z" 
        fill="#182c47"/>
    </svg>
);

interface FieldProps {
    label: string;
    placeholder: string;
    error?: string | null;
    type: string;
    value?: string;
    onChange?: (e: ChangeEvent<HTMLInputElement>) => void;
    onBlur?: (e: ChangeEvent<HTMLInputElement>) => void;
    name?: string;
}

const Field = forwardRef<HTMLInputElement, FieldProps>(
    ({ label, placeholder, error, type, value, onChange, onBlur, name, ...props }, ref) => {
        const [showPassword, setShowPassword] = useState(false);

        return (
            <div className="field">
                <label>{label}</label>
                <div className="input-container">
                    <input
                        ref={ref}
                        name={name}
                        type={type === 'password' ? (showPassword ? 'text' : 'password') : type}
                        placeholder={placeholder}
                        value={value}
                        onChange={onChange}
                        onBlur={onBlur}
                        {...props}
                    />
                    {type === 'password' && (
                        <button
                            type="button"
                            className="eye-button"
                            onMouseDown={() => setShowPassword(true)}
                            onMouseUp={() => setShowPassword(false)}
                            onMouseLeave={() => setShowPassword(false)}
                        >
                            {showPassword ? <EyeClosedIcon /> : <EyeIcon />}
                        </button>
                    )}
                </div>
                {error ? <span className="field-error">{error}</span> : <span style={{visibility: 'hidden'}}  className="field-error">1</span>}
            </div>
        );
    }
);

Field.displayName = 'Field';

export default Field;